// extracted by mini-css-extract-plugin
export default {"shadow":"alwQQV","sticked":"blwQQV","hidden":"clwQQV","positionTop":"dlwQQV","positionBottom":"elwQQV","positionXleft":"flwQQV","positionXcenter":"glwQQV","positionXright":"hlwQQV"};